import { TextProps } from '../Input/Text/Text'

export enum InputTypeEnum {
	TEXT = 'text'
}

export type ArrayFormFieldType = { inputType: InputTypeEnum } & TextProps

export type ArrayFormFieldProps = {
	disabled?: boolean,
	fields: ArrayFormFieldType[],
	name: string,
	title: string
}
